enum ListingTypeEnum {
  Article = 'article',
  Colour = 'colour',
  Product = 'product',
  Inspiration = 'inspiration',
}

export default ListingTypeEnum;
